import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface WorkoutReactResult {
  message: string;
  cached: boolean;
}

export const useWorkoutReact = () => {
  const [reaction, setReaction] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const react = useCallback(async (workoutSessionId: string, language: string) => {
    setIsLoading(true);
    setError(null);
    setReaction(null);
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("not_authenticated");
      const { data, error: fnError } = await supabase.functions.invoke("workout-react", {
        body: { user_id: user.id, workout_session_id: workoutSessionId, language },
      });
      if (fnError) throw fnError;
      const result = data as WorkoutReactResult;
      if (!result?.message) throw new Error("empty_response");
      setReaction(result.message);
    } catch (err: any) {
      console.error("[useWorkoutReact] failed", err);
      setError(err?.message || "unknown");
      setReaction(null);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const clear = useCallback(() => { setReaction(null); setError(null); }, []);

  return { reaction, isLoading, error, react, clear };
};
